import { Link } from "react-router-dom";

const stats = [
  { value: "12,800+", label: "精选图片" },
  { value: "320+", label: "写真专辑" },
  { value: "180+", label: "签约摄影师" },
  { value: "56万", label: "月度浏览" },
];

export default function SiteIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-100 px-6 py-10 md:px-10 md:py-14">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-heart-3-line"></i>
            关于美女网站
          </span>
          <h1 className="mt-4 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-4xl">
            美女网站 · 精选美女图片与娱乐内容分享平台
          </h1>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
            我们专注于呈现高品质的人像与写真作品，聚合日系、欧美、街拍、清新、复古等多元风格。
            无论是随手浏览，还是收藏心仪之作，你都能在这里找到属于自己的一片视觉花园。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/gallery"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-image-2-line"></i>
              开始浏览图片
            </Link>
            <Link
              to="/photobooks"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看写真专题
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-200 bg-background-50 px-5 py-6 text-center"
            >
              <p className="font-heading text-2xl font-semibold text-primary-600 md:text-3xl">
                {item.value}
              </p>
              <p className="mt-1.5 text-xs text-foreground-600">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}